import { Link } from 'react-router-dom'
import { causesData } from '../data/data'

export default function Causes() {
  return (
    <>
      <div className="row justify-content-center">
                <div className="col-12">
                    <div className="section-title text-center mb-4 pb-2">
                        <h4 className="title mb-3">Popular Causes</h4>
                        <p className="text-muted para-desc mx-auto mb-4">
                            The Tu Es Belle foundation is a non profit organisation that strives to improve the society by reminding women of their worth.
                        </p>
                    </div>
                </div>
            </div>

            <div className="row g-4">
                {causesData.map((item,index)=>{
                    return(
                        <div className="col-lg-4 col-md-6" key={index}>
                            <div className="position-relative rounded bg-white shadow overflow-hidden">
                                <div className="position-relative overflow-hidden">
                                    <img src={item.image} className="img-fluid" alt=""/>
                                    <div className="bg-overlay bg-linear-gradient-2"></div>
                                    <div className="position-absolute bottom-0 p-4">
                                        <Link to="/donate" className="text-white title-dark fw-semibold link-title">Donate Now <i className="mdi mdi-arrow-right"></i></Link>
                                    </div>
                                </div>

                                <div className="content p-4">
                                    <h5><h5 className="text-dark link-title">{item.title}</h5></h5>
                                    <p className="text-muted mb-0">{item.desc}</p>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div> 
    </>
  )
}
